import { useEffect } from 'react';
import { graphql, useFragment } from 'react-relay';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

import { useIsBelowEstimatedValueMaxRange } from '../PdpSharedPricingGuidance/helpers/useGetEstimatedValueRange';

import { type useRemoveNegotiationTest_item$key } from './__generated__/useRemoveNegotiationTest_item.graphql';

const REMOVE_NEGOTIATION_TEST_NAME = 'PDP_PricingGuidanceRemoveNegotiation_July2025';

const itemFragment = graphql`
    fragment useRemoveNegotiationTest_item on Item {
        ...useGetEstimatedValueRange_item
    }
`;

const useIsRemoveNegotiationTestVariant = (): boolean => {
    if (typeof window !== 'undefined') {
        return getAbTestV2(REMOVE_NEGOTIATION_TEST_NAME)?.variant === 'variant';
    }

    return false;
};

export const useRemoveNegotiation = ({
    item: itemRef,
    currency,
}: {
    item: useRemoveNegotiationTest_item$key;
    currency: string;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);

    const isBelowEstimatedValueMaxRange = useIsBelowEstimatedValueMaxRange({ item, currency });
    const isRemoveNegotiationTestVariant = useIsRemoveNegotiationTestVariant();

    return isRemoveNegotiationTestVariant && isBelowEstimatedValueMaxRange;
};

export const useTrackRemoveNegotiationTest = ({
    item: itemRef,
    currency,
}: {
    item: useRemoveNegotiationTest_item$key | null;
    currency: string;
}): void => {
    const item = useFragment(itemFragment, itemRef) || null;

    const isBelowEstimatedValueMaxRange = useIsBelowEstimatedValueMaxRange({ item, currency });

    useEffect(() => {
        if (isBelowEstimatedValueMaxRange) {
            trackAbTestV2Variant(REMOVE_NEGOTIATION_TEST_NAME);
        }
    }, [isBelowEstimatedValueMaxRange]);
};
